import { VehicleCategoryTipDialog, FormLabelsPicker } from '@shared/components';
import { FormSelect, FormInput, Button, Form } from '@ui/components';
import { VehicleCategory, LabelType } from '@interfaces/models';
import { VehicleCountryCodes } from '@helpers/constant';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

import { VehicleForm } from '../../../hooks';

interface VehiclesFormProps {
  form: UseFormReturn<VehicleForm>;
  isFormDisabled?: boolean;
  onSubmit: (data: VehicleForm) => void;
}

export const VehiclesForm: FC<VehiclesFormProps> = (props) => {
  const { form, onSubmit, isFormDisabled = false } = props;

  const { t } = useTranslation();

  const categoryOptions = Object.values(VehicleCategory).map((category) => ({
    label: t(`VEHICLE_CATEGORY.${category}`),
    value: category,
  }));

  return (
    <div>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6 mb-8">
          <div className="grid grid-cols-6 gap-4">
            <FormInput
              componentProps={{
                hasShadow: true,
                id: 'registrationNumber',
              }}
              placeholder={t('ONBOARDING.ADD_VEHICLES.REGISTRATION_NUMBER')}
              className="w-full col-span-4"
              formControl={form.control}
              disabled={isFormDisabled}
              name="registrationNumber"
              size="large"
              required
              floating
            />

            <FormSelect
              componentProps={{
                hasShadow: true,
              }}
              placeholder={t('ONBOARDING.ADD_VEHICLES.REGISTRATION_COUNTRY')}
              className="w-full col-span-2"
              options={VehicleCountryCodes}
              formControl={form.control}
              name="registrationCountry"
              disabled={isFormDisabled}
              size="large"
              required
              floating
            />
          </div>

          <div className="flex items-center gap-4">
            <FormSelect
              componentProps={{
                hasShadow: true,
              }}
              placeholder={t('ONBOARDING.ADD_VEHICLES.VEHICLE_CATEGORY')}
              className="w-full col-span-2"
              formControl={form.control}
              options={categoryOptions}
              disabled={isFormDisabled}
              name="vehicleCategory"
              size="large"
              required
              floating
            />

            <VehicleCategoryTipDialog>
              <Button variant="link" type="button" size="large">
                {t('ONBOARDING.ADD_VEHICLES.TIP')}
              </Button>
            </VehicleCategoryTipDialog>
          </div>

          <FormInput
            componentProps={{
              hasShadow: true,
              id: 'vehicleName',
            }}
            placeholder={t('ONBOARDING.ADD_VEHICLES.VEHICLE_NAME')}
            className="w-full col-span-4"
            formControl={form.control}
            disabled={isFormDisabled}
            size="large"
            name="name"
            floating
          />

          <FormLabelsPicker
            placeholder={t('ONBOARDING.ADD_VEHICLES.VEHICLE_LABEL')}
            componentProps={{ hasShadow: true, id: 'labels' }}
            labelType={LabelType.VEHICLE}
            className="w-full col-span-4"
            formControl={form.control}
            disabled={isFormDisabled}
            name="labels"
            size="large"
            floating
          />
        </form>
      </Form>
    </div>
  );
};
